import { Component, OnInit, Query } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PayonlineService } from '../payonline.service';

// Add this somewhere in your TypeScript code, e.g., at the top of your file
interface Window {
  ReactNativeWebView?: {
    postMessage: (message: string) => void;
  };
}


@Component({
  selector: 'app-success-or-failure',
  templateUrl: './success-or-failure.component.html',
  styleUrls: ['./success-or-failure.component.scss']
})
export class SuccessOrFailureComponent implements OnInit {
  errorOrNot: any;
  data: any;
  paymentAmount: any;
  res: any;
  pdf: any = false;
  pdfUrl: string;



  constructor(private route: ActivatedRoute, private payment: PayonlineService) { }
  ngOnInit() {
    this.route.queryParams.subscribe((params: any) => {
      console.log('Query Params:', params);
      this.res = JSON.parse(params.res)
      if (this.res.status == "OK") {
        this.errorOrNot = false;
      }
      else {
        this.errorOrNot = true;
      }
      this.data = this.res.responseObj
      console.log(this.data)
      this.paymentAmount = params.amount
    });
  }

  //   downlodPdf() {
  //     // this.payment.downloadPdf(encodeURI(this.data.encryptReferenceId)).subscribe({
  //     //   next:(res:any)=>{
  //     //     console.log(res)
  //     //     this.pdf=true;
  //     //     this.pdfUrl = URL.createObjectURL(res);

  //     //   }
  //     // })
  //     // Send data to React Native app

  //  if (!this.data?.encryptReferenceId) return;

  //   const encryptReferenceId = this.data.encryptReferenceId;

  //   // Send message to React Native
  //   if (window.ReactNativeWebView?.postMessage) {
  //     window.ReactNativeWebView.postMessage(
  //       JSON.stringify({ encryptReferenceId })
  //     );
  //     console.log('Sent to React Native:', encryptReferenceId);
  //   } else {
  //     console.log('Not inside a React Native WebView');
  //   }

  //   }

  downlodPdf() {
    if (!this.data?.encryptReferenceId) return;

    const encryptReferenceId = this.data.encryptReferenceId;

    // Cast window as any to avoid TS error
    const win: any = window;

    if (win.ReactNativeWebView?.postMessage) {
      win.ReactNativeWebView.postMessage(
        JSON.stringify({ encryptReferenceId })
      );
      console.log('Sent to React Native:', encryptReferenceId);
    } else {
      console.log('Not inside a React Native WebView');
    }
  }

}
